import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/front-pages/shape1.png'
import _imports_1 from '@/assets/images/front-pages/shape2.png'


const _hoisted_1 = { class: "py-[60px] md:py-[80px] lg:py-[100px] xl:py-[150px]" }
const _hoisted_2 = { class: "container md:max-w-[960px] 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]" }
const _hoisted_3 = { class: "text-center mx-auto md:max-w-[680px] lg:max-w-[830px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-[28px] md:text-[36px] lg:text-[45px] xl:text-[48px] mb-[13px] md:mb-[20px] lg:mb-[25px] xl:mb-[35px] -tracking-[.5px] md:-tracking-[.8px] lg:-tracking-[1.2px] xl:-tracking-[1.5px] leading-[1.2]" }, " Unleash the Full Potential of Your Business with Click AI ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mx-auto leading-[1.6] md:max-w-[650px] lg:max-w-[680px] xl:max-w-[740px] md:text-[15px] lg:text-[16px] xl:text-[18px] xl:tracking-[.2px]" }, " Let ClickAI show you what the future looks like. Talk to our sales team and see how AI can take over the busywork – so you can focus on growing. ", -1)),
        _createVNode(_component_RouterLink, {
          to: "/contact",
          class: "inline-block lg:text-[15px] xl:text-[16px] mt-[5px] md:mt-[10px] lg:mt-[20px] xl:mt-[30px] py-[12px] px-[17px] bg-purple-600 text-white rounded-md transition-all font-medium hover:bg-purple-500"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]" }, [
              _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]" }, " contact_support "),
              _createTextVNode(" Contact us ")
            ], -1)
          ])),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute ltr:left-[10px] rtl:right-[10px] -top-[200px] -z-[1] blur-[150px]" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "shape1"
        })
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute ltr:right-[25px] rtl:left-[25px] top-[150px] -z-[1] blur-[125px] hidden md:block" }, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: "shape1"
        })
      ], -1))
    ])
  ]))
}